export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OrderDetails.vue?vue&type=template&id=307277ee&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/OrderDetails.vue?vue&type=template&id=307277ee&scoped=true
// module id = 2334
// module chunks = 31